// @flow
import * as React from 'react';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

// components
import { Container, Row, Col } from 'reactstrap';
import Button from 'components/atoms/Button';
import Modal from 'components/atoms/Modal';
import TermsPrivacy from 'components/pages/components/ContentFooter/components/TermsPrivacy';

// Utils
import { getMetaTagContentByName, setLanguageTag } from 'utils/DOM';

import xtimeLogo from './xtimelogo.svg';

import './ContentFooter.scss';
import classNames from 'classnames';

const ns = 'content-footer';

type OwnProps = {
  localizationStrings: string => string,
  intl: IntlShape,
  getLanguagesAvailable: Array<Object>,
  languagesAvailableGreaterThanOne: boolean,
  changeLocale: string => void,
  dealerLocaleName: string,
  getLocaleCode: string,
  localizationKeys: Object => Object,
  className?: string
};

type Ref = {
  current: any
};

type Props = OwnProps;

class ContentFooter extends React.Component<Props> {
  cancelApptmodal: Ref = React.createRef();

  versionNumberFormat = (versionNumber: String) => {
    let versionFormatted = versionNumber;
    versionFormatted = versionFormatted.split('-')[0].split('.');
    return versionFormatted[2] === '0'
      ? versionFormatted.slice(0, 2).join('.')
      : versionFormatted.join('.');
  };

  async selectLanguage(locale: string) {
    const { changeLocale } = this.props;
    const data = await changeLocale(locale);
    const success = data && data.success;
    setLanguageTag(locale);
    if (success) {
      document.body && document.body.classList.remove('modal-open');
    }
  }

  buildChangeLanguageSelectionModal() {
    const {
      intl,
      getLanguagesAvailable,
      getLocaleCode,
      localizationKeys
    } = this.props;
    const languageChangeLocalizationKey = localizationKeys
      ? localizationKeys.changeLanguageTitle
      : 'c8.content.footer.select.your.language';
    return (
      <Modal
        ref={this.cancelApptmodal}
        size={'medium'}
        showCloseButton={true}
        ariaCloseId="c8.aria.close.language.modal"
        ariaCloseDefault="Close Language Preferences Modal"
      >
        <h1 className={`${ns}__title mb-5`}>
          {intl.formatMessage({
            id: languageChangeLocalizationKey
          })}
        </h1>
        <div
          tabIndex={0}
          aria-modal={true}
          aria-label={intl.formatMessage({
            id: 'c8.aria.change.language',
            defaultMessage: 'Change Language'
          })}
        >
          {getLanguagesAvailable.map(language => {
            const classButton = classNames({
              [`${ns}__language-button`]: getLocaleCode !== language.localeCode,
              [`${ns}__language-button--selected`]:
                getLocaleCode === language.localeCode
            });
            return (
              <Button
                className={`${classButton} mb-4`}
                key={language.localeCode}
                buttonTheme="link"
                onClick={async () => {
                  await this.selectLanguage(language.localeCode);
                }}
                tabIndex={0}
              >
                {language.localeName}
              </Button>
            );
          })}
        </div>
      </Modal>
    );
  }

  render() {
    const {
      localizationStrings,
      localizationKeys,
      languagesAvailableGreaterThanOne,
      dealerLocaleName,
      intl,
      className
    } = this.props;
    const classProps = classNames(ns, 'pl-2 pr-0', {
      [`${ns}__${className}`]: className
    });
    let versionNumber = getMetaTagContentByName('xtime:releaseNumber');
    versionNumber = isNaN(versionNumber[0])
      ? 'CP8_DEV'
      : this.versionNumberFormat(versionNumber);
    const keys = {
      privacyText: localizationKeys
        ? localizationKeys.privacyText
        : 'c8.privacy.disclaimer',
      privacyTitle: localizationKeys
        ? localizationKeys.privacyTitle
        : 'c8.content.footer.privacy',
      termsText: localizationKeys
        ? localizationKeys.termsText
        : 'c8.review.book.disclaimer',
      termsTitle: localizationKeys
        ? localizationKeys.termsTitle
        : 'c8.content.footer.terms',
      urlXtime: localizationKeys
        ? localizationKeys.urlXtime
        : 'c8.common.footer.xtime.url'
    };
    return (
      <Container className={classProps}>
        {this.buildChangeLanguageSelectionModal()}
        <Row className={`${ns}--row`}>
          <Col
            aria-label={intl.formatMessage({
              id: 'c8.aria.footer',
              defaultMessage: 'Footer'
            })}
            className={'footer_container'}
          >
            <img
              tabIndex={0}
              aria-label={intl.formatMessage({
                id: 'c8.aria.continue.to.xtime.home.page',
                defaultMessage: 'Continue to Xtime Home Page'
              })}
              alt={intl.formatMessage({
                id: 'c8.aria.continue.to.xtime.home.page',
                defaultMessage: 'Continue to Xtime Home Page'
              })}
              className={`${ns}__xtime-logo ml-2`}
              src={xtimeLogo}
              onClick={() => window.open(localizationStrings(keys.urlXtime))}
            />
            <TermsPrivacy
              contentKey={keys.privacyText}
              titleKey={keys.privacyTitle}
              className={'footer-privacy'}
              isTerms={false}
            />
            <TermsPrivacy
              contentKey={keys.termsText}
              titleKey={keys.termsTitle}
              className={'footer-terms'}
              isTerms={true}
            />
            {languagesAvailableGreaterThanOne && (
              <Button
                buttonTheme="link"
                className={`${ns}__change-language-button ml-2`}
                onClick={() => this.cancelApptmodal.current.setShowModal(true)}
                tabIndex={0}
              >
                {dealerLocaleName}
              </Button>
            )}
            <div className={`${ns}__app-version ml-2`}>{versionNumber}</div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default ContentFooter;



// WEBPACK FOOTER //
// ./src/components/pages/components/ContentFooter/ContentFooter.js